import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ThemedSwitch from 'components/common/ThemedSwitch';
import { debounce } from 'lodash';
const ReadyCell = ({ cellValue, onChange, disabled, setRowBusy, }) => {
    const [value, setValue] = useState(false);
    useEffect(() => {
        setValue(cellValue.value);
        setRowBusy === null || setRowBusy === void 0 ? void 0 : setRowBusy((busy) => busy.filter((id) => id !== cellValue.id));
    }, [cellValue.value, cellValue.id, setValue, setRowBusy]);
    const debouncedChange = useMemo(() => debounce(onChange, 1000), [onChange]);
    const handleChange = useCallback((e) => {
        setValue(e.target.checked);
        setRowBusy === null || setRowBusy === void 0 ? void 0 : setRowBusy((busy) => [...busy, cellValue.id]);
        debouncedChange(cellValue.id, e.target.checked);
    }, [setRowBusy, debouncedChange, cellValue.id]);
    return React.createElement(ThemedSwitch, { onChange: handleChange, checked: value, disabled: disabled });
};
export default ReadyCell;
